<template>
  <div class="m_consulting">
    123
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>